import React from 'react'

const Ourbrand = () => {
  return (
    <div className='ourbrand'>ourbrand</div>
  )
}

export default Ourbrand